"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebtCollectionCardCms = void 0;
var DebtCollectionCardCms = /** @class */ (function () {
    function DebtCollectionCardCms() {
        this.termsLinkLabel = 'Read the One-time Payment Terms & Conditions';
        this.termsConsentChkBoxLabel = 'I have read and agree to the One-time Payment Terms & Conditions.';
        this.textLabel = 'The Text';
        this.totalbalanceDueLabel = 'Total balance due now';
        this.paymentTitleLabel = 'Payment info';
        this.paymentDetailConsentLabel = 'Provide your payment info, which will be used to make a ' +
            'one-time payment today for the total unpaid balance shown above.';
        this.accountNumberPlaceholderLabel = 'Account #';
        this.homePhoneDSLDisplayLabel = 'Home phone and/or DSL';
        this.uverseDisplayLabel = 'U-verse and/or bundled AT&T services';
        this.wirelessDiplayLabel = 'Wireless and/or Digital Life';
        this.directTvDisplayLabel = 'DIRECTV';
        this.emptyLabel = '';
        this.totalPaidTodayLabel = 'Total paid today';
        this.totalBalanceToPayLabel = 'Total balance to be paid';
        this.paymentUnsuccessfullMessageLabel = 'After you submit your order, we\'ll ' +
            'try to process your payment again. If the payment is unsuccessful, ' +
            'we\'ll contact you to resolve the matter.';
        this.debtPmtUnsuccessfullContinueOrderLabel = 'Please continue with your order.';
        this.debtPmtSuccessTitleLabel = 'We\'ve processed your payment successfully.';
        this.debtPmtSucessPrintLabel = 'Be sure to print or take a screenshot of this payment confirmation for your records.';
        this.transactionIdLabel = 'Transaction ID';
        this.paymentMethodLabel = 'Payment method';
        this.paymentDateLabel = 'Payment date';
    }
    return DebtCollectionCardCms;
}());
exports.DebtCollectionCardCms = DebtCollectionCardCms;
//# sourceMappingURL=DebtCollectionCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditResponseModal/DebtCollectionCard/DebtCollectionCard.cms.js
// module id = 2015
// module chunks = 8